const PAST_SHIFTS = { resourceType: true, unit: true, shiftFeature: true };

const UPCOMING_SHIFTS = {
	date: true,
	resourceType: true,
	unit: true,
	shiftStatus: true,
	shiftFeature: true,
	shiftRoutes: true
};

export { PAST_SHIFTS, UPCOMING_SHIFTS };
